import { render, staticRenderFns } from "./MappingAreaReportDataTable.vue?vue&type=template&id=4f6a94f4&"
import script from "./MappingAreaReportDataTable.vue?vue&type=script&lang=js&"
export * from "./MappingAreaReportDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports